import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './FineInformation.module.scss'
import { confirmFineNumberAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const ConfirmFineNumber = ({ t, confirmFineNumberValid, validateConfirmFineNumber, confirmFineNumberError, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const confirmFineNumber = useSelector((state) => state.app.confirmFineNumber)

  const handleConfirmFineNumber = (e) => {
    try {
      let number = e.currentTarget.value.replace(/\s/g, '')
      dispatch(confirmFineNumberAction(number))
      validateConfirmFineNumber(number)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const handleOnBlur = () => {
    SetIsFocussed(false)
    validateConfirmFineNumber(confirmFineNumber)
  }

  const handleOnPaste = (e) => {
    e.preventDefault()
    return false
  }

  return (
    <React.Fragment>
      <div className={styles['fields_margin']}>
        <div
          className={
            confirmFineNumberValid === true
              ? confirmFineNumber === ''
                ? ''
                : 'form-group has-success'
              : confirmFineNumberValid === false
              ? 'form-group has-error'
              : ''
          }
        >
          <label className="control-label" htmlFor="ConfirmFineNumber">
            {t('fine_information.confirm_fine_number')}
          </label>
          <input
            type="text"
            className={['ns-input form-control', styles['field_width']].join(' ')}
            id="ConfirmFineNumber"
            onBlur={handleOnBlur}
            value={confirmFineNumber}
            autoComplete="off"
            onChange={handleConfirmFineNumber}
            onFocus={() => SetIsFocussed(true)}
            onPaste={handleOnPaste}
            maxLength="10"
          />
          {confirmFineNumberValid === true ? (
            confirmFineNumber === '' ? (
              ''
            ) : (
              <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
            )
          ) : confirmFineNumberValid === false ? (
            <React.Fragment>
              <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
              <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(confirmFineNumberError)}</div>
            </React.Fragment>
          ) : (
            ''
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

export default withTranslation('common')(ConfirmFineNumber)
